const routes = {
  root: '/',
  games: {
    root: 'games/',
    saves: 'saves/',
  },
  settings: {
    root: 'settings/',
  },
  styles: 'styles/',
};

export const queries = {
  and: '&',
  root: '#',
  source: source => `source=${encodeURIComponent(source)}`
};

export default routes;
